import {
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { BrandIdvTokenDataFn } from "../../instantAnswerDataFunctions/brandIdvTokenDataFn";

import { getSubmitVerificationInformationCTA } from "./shared";

export const SubmitRequestedInformationIA: InstantAnswerBuilderFn = (
  strictLocalize
) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getSubmitVerificationInformationCTA(context, strictLocalize)
          ?.label;
      },
      linkBuilder: (context) => {
        return getSubmitVerificationInformationCTA(
          context,
          strictLocalize
        )?.getLink?.();
      },
    },

    additionalRequiredData: [BrandIdvTokenDataFn],
  };
};

const getAnswer = (
  context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => SUBMIT_REQUESTED_INFORMATION_TITLE(strictLocalize),
    getDescription: () => getDescriptionByContext(context, strictLocalize),
  };
};

const getDescriptionByContext = (
  context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
) => {
  if (context.brandIdvToken) {
    return [SUBMIT_REQUESTED_INFORMATION_DESCRIPTION(strictLocalize)];
  }
  return [
    SUBMIT_REQUESTED_INFORMATION_BY_CONTACTING_US_DESCRIPTION(strictLocalize),
  ];
};

const SUBMIT_REQUESTED_INFORMATION_TITLE = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "Submit requested information",
    description: {
      text: "Title for the answer of submitting requested information.",
    },
  });

const SUBMIT_REQUESTED_INFORMATION_DESCRIPTION = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "You can submit information for the verification of your Faire brand account using the button below.",
  });

const SUBMIT_REQUESTED_INFORMATION_BY_CONTACTING_US_DESCRIPTION = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "You can submit information for the verification of your Faire brand account by contacting us.",
  });
